export default __webpack_public_path__ + "static/media/trueFace.feaa3ee0.png";